// ActivityPlanGridPanel.tsx

import React from 'react';
import {
  Box,
  //Button,
  Paper,
  Stack,
  //Typography,
} from '@mui/material';

import {
  DataGrid,
  GridColDef,
  GridRowModel,
  GridRowModesModel,
  GridRowModes,
  GridActionsCellItem,
  //GridToolbar,
} from '@mui/x-data-grid';

import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Close';
import { BasicGridToolbar } from './BasicGridToolBar';
//import { fetchCombo } from '../core/coreapi';
import { ComboRow } from '../core/coremodels';
import { GridCodeCombo } from '../core/GridCodeCombo';
import { FDataGrid, FGridCodeCombo } from '../grid';
import { FGridDeleteAction, markRowDeleted, getGridRowKey } from '../grid';


declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    addRow: Function;
    saveAll?: Function;
    saving?: boolean;
    total?: number;
    [name:string]: any;
  }
}

type Props = {
  periods: ComboRow[];
  //periodCode?: string;
  rows: any[];
  onChange: (rows: any[]) => void;
  onSubmit: (rows: any[]) => Promise<void>;
};

type State = {
  rowModesModel: GridRowModesModel;
  //rowModesModel: GridRowModesModel;
  saving: boolean;
  periods: any[];
  errors: any;
  //periodCode: any;
};


class ActivityPlanGridPanel extends React.Component<Props, State> {

  state: State = {
    rowModesModel: {},
    saving: false,
    periods: [],
    errors: {},
  };

  columns: GridColDef[] = [
    {
      field: 'periodcode',
      headerName: 'Period',
      width: 120,
      editable: true,
      renderEditCell: (params) => (
      <GridCodeCombo 
        _svc={'budgetperiod'} 
        label
        items
        value
        onChange
        {...params} />
      )
    },
    {
      field: 'drivervalue',
      headerName: 'Driver Value',
      type: 'number',
      width: 140,
      editable: true,
    },
    {
      field: 'targetvalue',
      headerName: 'Target',
      type: 'number',
      width: 130,
      editable: true,
    },
    {
      field: 'plannedamount',
      headerName: 'Planned Amount',
      type: 'number',
      width: 160,
      editable: true,
    },
    {
      field: 'state',
      headerName: 'State',
      width: 120,
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      minWidth: 250,
      editable: true,
    },
    {
      field: 'actions',
      type: 'actions',
      width: 90,
      
    }
  ];

  gridActions0 = (params:any) => {
    const isEditing =
      this.state.rowModesModel[params.id]?.mode === GridRowModes.Edit;

    if (isEditing) {
      return [
        <GridActionsCellItem
          icon={<SaveIcon />}
          label="Save"
          onClick={() => this.handleSaveClick(params.id)}
        />,
        <GridActionsCellItem
          icon={<CancelIcon />}
          label="Cancel"
          onClick={() => this.handleCancelClick(params.id)}
        />
      ];
    }

    return [
      <GridActionsCellItem
        icon={<EditIcon />}
        label="Edit"
        onClick={() => this.handleEditClick(params.id)}
      />
    ];
  };

  gridActions = (params: any) => {
    const isEditing = this.state.rowModesModel[params.id]?.mode === GridRowModes.Edit;

    if (isEditing) {
      return [
        <GridActionsCellItem icon={<SaveIcon />} label="Save" onClick={() => this.handleSaveClick(params.id)} />,
        <GridActionsCellItem icon={<CancelIcon />} label="Cancel" onClick={() => this.handleCancelClick(params.id)} />,
      ];
    }

    return [
      <GridActionsCellItem icon={<EditIcon />} label="Edit" onClick={() => this.handleEditClick(params.id)} />,
      <FGridDeleteAction id={params.id} onDelete={this.deleteRow} />,
    ];
  };

  renderPeriods = (params:any) =>  <GridCodeCombo label={"Period"} items={this.props.periods} value={params.value || ''} onChange={this} {...params} />
  
  getColumns0 = (periods:any[]): GridColDef[] => [
    {
      field: 'periodcode',
      headerName: 'Period',
      width: 120,
      editable: true,
      renderEditCell: (params) => (
        <GridCodeCombo label="Period" items={periods || []} /*value={params.value || ''}*/ {...params} />
      ),
    },
    { field: 'drivervalue', headerName: 'Driver Value', type: 'number', width: 140, editable: true },
    { field: 'targetvalue', headerName: 'Target / Cible', type: 'number', width: 130, editable: true },
    { field: 'plannedamount', headerName: 'Planned Amount', type: 'number', width: 160, editable: true },
    //{ field: 'thresholdmax', headerName: 'Max Threshold', type: 'number', width: 150, editable: true },
    { field: 'state', headerName: 'State', width: 120 },
    { field: 'description', headerName: 'Description', flex: 1, minWidth: 250, editable: true },
    { field: 'actions', type: 'actions', width: 90, getActions: this.gridActions }
  ];

    addRow = () => {
      const newRow = {
      id: `new-${Date.now()}`,
      //rid: null,
      periodcode: '',
      drivervalue: 0,
      targetvalue: 0,
      plannedamount: 0,
      state: 'Draft',
      description: '',
      _state: 'new',
    };
    
    this.props.onChange([
      ...this.props.rows,
      newRow
    ]);
  };

  deleteRow = (id: any) => {
    this.props.onChange(markRowDeleted(this.props.rows, id));
  };

  handleEditClick = (id: any) => {
    this.setState({
      rowModesModel: {
        ...this.state.rowModesModel,
        [id]: { mode: GridRowModes.Edit }
      }
    });
  };

  handleSaveClick = (id: any) => {
    this.setState({
      rowModesModel: {
        ...this.state.rowModesModel,
        [id]: { mode: GridRowModes.View }
      }
    });
  };

  handleCancelClick = (id: any) => {
    this.setState({
      rowModesModel: {
        ...this.state.rowModesModel,
        [id]: {
          mode: GridRowModes.View,
          ignoreModifications: true
        }
      }
    });
  };

  processRowUpdate = (newRow: GridRowModel) => {
    const rows = this.props.rows.map(r =>
      //r.id === newRow.id ? newRow : r
      r.id === newRow.id? { ...r, ...newRow, _state: (r.rid||r.recid) ? 'dirty' : 'new' }: r
    );
    this.props.onChange(rows);
    return newRow;
  };

  saveAll = async () => {
    this.setState({ saving: true });

    try {
      // Save payload should include deleted rows:
      // const payloadRows = this.state.activityPlanRows
      //   .filter((r:any) => r._state && r._state !== 'clean')
      //   .map((r:any) => ({
      //     rid: r.rid || r.recid || null,
      //     periodcode: r.periodcode,
      //     drivervalue: Number(r.drivervalue || 0),
      //     targetvalue: Number(r.targetvalue || 0),
      //     plannedamount: Number(r.plannedamount || 0),
      //     description: r.description || '',
      //     status: r._state === 'deleted' ? 0 : 1,
      //     _state: r._state,
      //   }));

      await this.props.onSubmit(this.props.rows);
    } finally {
      this.setState({ saving: false });
    }
  };

  // gridActions = (params: any) => {
  //   const isEditing = this.state.rowModesModel[params.id]?.mode === GridRowModes.Edit;

  //   if (isEditing) {
  //     return [
  //       <GridActionsCellItem icon={<SaveIcon />} label="Save" onClick={() => this.handleSaveClick(params.id)} />,
  //       <GridActionsCellItem icon={<CancelIcon />} label="Cancel" onClick={() => this.handleCancelClick(params.id)} />,
  //     ];
  //   }

  //   return [
  //     <GridActionsCellItem icon={<EditIcon />} label="Edit" onClick={() => this.handleEditClick(params.id)} />,
  //   ];
  // };

  getColumns = (): GridColDef[] => [
    {
      field: 'periodcode',
      headerName: 'Period',
      width: 120,
      editable: true,
      renderEditCell: (params) => (
        <FGridCodeCombo
          label="Period"
          items={this.props.periods || []}
          value={params.value || ''}
          autoOpen
          {...params}
        />
      ),
    },
    { field: 'drivervalue', headerName: 'Driver Value', type: 'number', width: 140, editable: true },
    { field: 'targetvalue', headerName: 'Target / Cible', type: 'number', width: 130, editable: true },
    { field: 'plannedamount', headerName: 'Planned Amount', type: 'number', width: 160, editable: true },
    { field: 'state', headerName: 'State', width: 120 },
    { field: 'description', headerName: 'Description', flex: 1, minWidth: 250, editable: true },
    { field: 'actions', type: 'actions', width: 120, getActions: this.gridActions },
  ];

  render() {
    const {saving} = this.state;
    const {periods} = this.props;

    return (
      <Paper elevation={0} sx={{ p: 0 }}>

        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
        </Stack>

        <Box sx={{ height: 420 }}>

          {/* <DataGrid
            rows={this.props.rows}
            columns={this.getColumns(periods)}
            getRowId={(row) => row.rid || row.id}
            editMode="row"
            rowModesModel={this.state.rowModesModel}
            processRowUpdate={this.processRowUpdate}
            onRowModesModelChange={(model) =>
              this.setState({ rowModesModel: model })
            }
            onProcessRowUpdateError={(err) => console.error(err)}
            showToolbar
            slots={{ toolbar: BasicGridToolbar }}
            slotProps={{
              toolbar: { addRow: this.addRow, saveAll: this.saveAll, saving , title: 'Activity Plan', sx: {backgroundColor: '#e7f6ea'} },
            }}
            pageSizeOptions={[10, 20, 50]}
            disableRowSelectionOnClick
          /> */}

          <FDataGrid
                  title="Activity Plan"
                  rows={this.props.rows}
                  columns={this.getColumns()}
                  height={420}
                  addRow={this.addRow}
                  onRowsChange={this.props.onChange}
                  onSubmit={this.props.onSubmit}
                  toolbarSx={{ backgroundColor: '#e7f6ea' }}
                  rowModesModel={this.state.rowModesModel}
                  onRowModesModelChange={(model) => this.setState({ rowModesModel: model })}
                />

        </Box>

      </Paper>
    );
  }
}

export default ActivityPlanGridPanel;




// Handler:




